import { PersonQualification } from "../../utils/Helper";
import {PersonType, CivilStatus, OptionsWhyWithoutTIN} from "./Person/types";

export const preCheckAccountForm = (account, options = {}) => {
  const { skipAdvisorValidation = false } = options;
  const errors = {};
  Object.keys(account).forEach(key => {
    switch (key) {
      case "AccountName":
        if (!account[key] && String(account[key] !== '')) {
          errors[key] = "This field is required.";
        }
        break;
      //case "AccountEmail":
      case "AccountNumber":
        if(!account[key]||account[key]==0){
          errors[key]="This value cant be 0.";
        }
      case "AccountProfileRiskId":
      case "AccountCurrencyId":
      case "AccountCompanyLinkId":
      case "AccountWayGiveOrders":
      case "AccountBookInfo":
      case "AccountUsage":
        if (!account[key]) {
          errors[key] = "This field is required.";
        }
        break;
      case "AccountAsksCustody":
      case "AccountAutomaticCreditCoupon":
      case "AccountAutomaticCreditSink":
        if (typeof account[key] !== "boolean") {
          errors[key] = "This field is required.";
        }
        break;
      case "MainAdvisorCommissionPercentage":
        if (skipAdvisorValidation) {
          break;
        }
        if (!account[key] && parseFloat(account[key] !== 0)) {
          errors[key] = "This numeric field is required.";
        }
        break;
        case "MainAdvisorId":
          if (skipAdvisorValidation) {
            break;
          }
          if ((!account[key]) && (String(account[key]) === "")) {
            errors[key] = "This field is required.";
          }
          if ((account[key]) && (String(account[key]) === "0")) {
            errors[key] = "This field is required.";
          }
          break;
        case "RepId":
          if (skipAdvisorValidation) {
            break;
          }
          if ((!account[key]) && (String(account[key]) === "")) {
            errors[key] = "This field is required.";
          }
          if ((account[key]) && (String(account[key]) === "0")) {
            errors[key] = "This field is required.";
          }
          break;
      default:
        break;
    }
  });
  return errors;
};

export const preCheckNewAccountForm = account => {
  const errors = {};
  Object.keys(account).forEach(key => {
    switch (key) {
      case "AccountName":
      //case "AccountEmail":
      case "AccountCurrencyId":
        case "MainAdvisorId":
          if (!account[key] && parseFloat(account[key] === "")) {
            errors[key] = "This numeric field is required.";
          }
          break;
        case "RepId":
          if (!account[key] && parseFloat(account[key] === "")) {
            errors[key] = "This numeric field is required.";
          }
          break;
          case "MainAdvisorName":
            if (!account[key] && parseFloat(account[key] === "")) {
              errors[key] = "This numeric field is required.";
            }
            break;
          case "RepName":
            if (!account[key] && parseFloat(account[key] === "")) {
              errors[key] = "This numeric field is required.";
            }
            break;
      case "AccountCompanyLinkId":
      case "AccountWayGiveOrders":
      case "AccountBookInfo":
        if (!account[key]) {
          errors[key] = "This field is required.";
        }
        break;
      case "AccountAsksCustody":
      case "AccountAutomaticCreditCoupon":
      case "AccountAutomaticCreditSink":
        if (typeof account[key] !== "boolean") {
          errors[key] = "This field is required.";
        }
        break;
      case "MainAdvisorCommissionPercentage":
        if (!account[key] && parseFloat(account[key] !== 0)) {
          errors[key] = "This numeric field is required.";
        }
        break;
      default:
        break;
    }
  });
  return errors;
};

export const preCheckPhysicalPersonForm = person => {
  const errors = {};
  const needsExtraFields= person.needsExtraFields? true: false;
  Object.keys(person).forEach(key => {
    switch (key) {
      case "PhysicalPersonWorkHistoryYears":
        if (person[key] && String(Math.abs(person[key])).length > 3){
          errors[key] = "Work History Years shouldn't have more than 3 digits.";
        }
        break;
      case "PhysicalPersonNationality":
      case "PhysicalPersonSecondName":
      case "PhysicalPersonSecondLastName":
      case "PhysicalPersonInstitution":
         if (needsExtraFields&&!person[key]&&!person.PersonIsMinimal) {
          errors[key] = "This field is required.";
        }
        break;
      case "PhysicalPersonFirstName":
      case "PhysicalPersonFirstLastName":
      case "PersonQualification":
      case "PhysicalPersonMainDocumentNumber":
        if (!person[key]) {
          errors[key] = "This field is required.";
        }
        break;
      case "PhysicalPersonEmail":
      case "PhysicalPersonDateOfBirth":
      case "PhysicalPersonCountryOfBirthId":
      case "PhysicalPersonCityOfBirthId":
      case "PhysicalPersonGender":
      case "PhysicalPersonPublicPositionId":
      case "PersonFiscalResidenceCountryId":
      case "PhysicalPersonCivilStatus":
        if (!person[key] && !person.PersonIsMinimal&&(!person.PersonUpdateManual || (person.PersonUpdateManual === "0"))) {
          errors[key] = "This field is required.";
        }
        break;
      case "PersonFiscalResidenceNoTINOpt":
        if (person.PersonFiscalResidenceNoTINOpt == "" && !person.PersonIsMinimal) {
          person.PersonFiscalResidenceNoTINOpt = "";
        }
        break;
      case "PersonFiscalResidenceNoTINSpecify":
        if (
          !person.PersonFiscalResidenceTIN &&
          person.PersonFiscalResidenceNoTINOpt === "Option2" &&
          !person[key] && !person.PersonIsMinimal
        ) {
          errors[key] = "This field is required.";
        }
        break;
      case "PhysicalPersonPatrimonyId":
        if (
          (!person[key] || person[key] == 0) && !person.PersonIsMinimal
        ) {
          errors[key] = "This field is required.";
        }
        break;
      case "PersonLinkPublicPositionId":
        if (
          !person.PersonIsMinimal &&
          (!person[key] ||
            (parseInt(person.PhysicalPersonLinkId, 10) > 10 &&
              parseInt(person[key], 10) === 1))
        ) {
          errors[key] = "This field is required.";
        }
        break;
      case "PhysicalPersonLinkId":
        if (
          !person.PersonIsMinimal &&
          (!person[key] ||
            (parseInt(person.PersonLinkPublicPositionId, 10) > 10 &&
              parseInt(person[key], 10) === 1))
        ) {
          errors[key] = "This field is required.";
        }
        break;
      case "PersonProfessionId":
      case "PersonActivitySectorId":
        if (person[key]==0 && !person.PersonIsMinimal && (!person.PersonUpdateManual || (person.PersonUpdateManual === "0"))){
          errors[key] = "This field is required.";
        }
        break;
      default:
        break;
    }
  });
  return errors;
};

export const preCheckJuridicalPersonform = person => {
  const errors = {};
  const needsExtraFields= person.needsExtraFields? true: false;
  Object.keys(person).forEach(key => {
    switch (key) {
      // case "PersonProfessionId":
      case "PersonActivitySectorId":
        if (person[key]==0 && !person.PersonIsMinimal && (!person.PersonUpdateManual || (person.PersonUpdateManual === "0"))){
          errors[key] = "This field is required.";
        }
        break;
  
      case "JuridicalPersonTAXId":
        if (!person[key]||person[key].trim() == "" ) {
          errors[key] = "This field is required.";}
          break;
      case "JuridicalPersonConstPlaceId":
      case "JuridicalPersonDocumentTypeId":
      case "JuridicalPersonLegalName":
      case "PersonQualification":
        if (!person[key]||person[key].trim() == "") {
          errors[key] = "This field is required."
        }
          break;
      case "JuridicalPersonConstDate":
        if (!person[key]||person[key].trim() == "" ) {
          errors[key] = "This field is required.";}
          break;
      case "JuridicalPersonIssuePlace":
      case "JuridicalPersonPublicPosition":
        if (!person[key]||person[key].trim() == "") {
          errors[key] = "This field is required."
        }
        break;
      case "PersonEmail":
        if (!person[key]&&needsExtraFields&&!person.PersonIsMinimal) {
          errors[key] = "This field is required.";
        }
        break;
      default:
        break;
    }
  });
  return errors;
};

export const preCheckPersonForm = person => {
  const addrErrors = {};
  let errors = {};
  if (person.PersonType === PersonType.Juridical) {
    errors = preCheckJuridicalPersonform(person);
  } else {
    errors = preCheckPhysicalPersonForm(person);
  }
  return {
    ...errors,
    ...addrErrors
  };
};
